import React from "react";
import { useNavigate } from "react-router-dom";

const LowerLegFrontPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .llf-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #f0fdf4 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .llf-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .llf-hero {
          padding: 24px 22px 30px;
          border-radius: 28px;
          background: linear-gradient(115deg, rgba(34, 197, 94, 0.18), rgba(56, 189, 248, 0.07));
          margin-bottom: 32px;
          display: grid;
          grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .llf-hero {
            grid-template-columns: 1fr;
          }
        }

        .llf-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(22, 163, 74, 0.18);
          color: #166534;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .llf-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #16a34a;
        }

        .llf-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .llf-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .llf-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .llf-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .llf-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .llf-btnPrimary,
        .llf-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .llf-btnPrimary {
          background: #16a34a;
          color: #ecfdf5;
          box-shadow: 0 9px 22px rgba(22, 163, 74, 0.34);
        }

        .llf-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(22, 163, 74, 0.48);
        }

        .llf-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .llf-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .llf-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .llf-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* STRIPES */
        .llf-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .llf-sectionTitle {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .llf-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .llf-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .llf-flexCol {
          flex: 1 1 260px;
        }

        .llf-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .llf-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .llf-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .llf-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #16a34a;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .llf-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .llf-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .llf-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .llf-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE / STEPS */
        .llf-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .llf-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .llf-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .llf-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .llf-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .llf-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .llf-banner img {
            height: 260px;
          }
        }

        .llf-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.8), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .llf-bannerText {
          color: #dcfce7;
          font-size: 15px;
          max-width: 420px;
        }

        .llf-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .llf-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .llf-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .llf-bannerButtons .secondary {
          background: rgba(255, 255, 255, 0.18);
          color: #f9fafb;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        /* BOTTOM STRIP */
        .llf-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .llf-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .llf-bottomText strong {
          color: #fef9c3;
        }

        .llf-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .llf-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .llf-bottomActions .primary {
          background: #16a34a;
          color: #ecfdf5;
        }

        .llf-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .llf-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="llf-page">
        <div className="llf-inner">
          {/* HERO */}
          <section className="llf-hero">
            <div>
              <div className="llf-tag">
                <span className="llf-tagDot" />
                Lower Leg · Front & Outer
              </div>
              <h1 className="llf-title">
                Calm shin and outer lower leg pain so walking and standing feel lighter.
              </h1>
              <p className="llf-subtitle">
                The tibialis anterior (front shin) and fibularis/peroneal muscles (outer lower leg)
                help lift your foot, control your step, and support your ankle. When they&apos;re irritated,
                every step can feel tight, achy, or overworked.
              </p>

              <div className="llf-chips">
                <span className="llf-chip">Shin tightness</span>
                <span className="llf-chip">Outer lower leg pain</span>
                <span className="llf-chip">Foot slap or fatigue</span>
                <span className="llf-chip">Early “shin splint” feelings</span>
              </div>

              <div className="llf-ctaRow">
                <button
                  className="llf-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a lower leg visit →
                </button>
                <button
                  className="llf-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="llf-heroImgWrap">
              <img
                src="/content/lower-leg-front/lower_leg_hero.png"
                alt="Therapist assessing front of lower leg and shin"
                className="llf-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="llf-stripe">
            <div className="llf-sectionTitle">What can go wrong in the front & outer lower leg?</div>
            <p className="llf-sectionSubtitle">
              These muscles help lift the foot and control side-to-side stability. They can get irritated
              with walking, running, standing, or changes in footwear or surfaces.
            </p>

            <div className="llf-flexRow">
              <div className="llf-flexCol">
                <ul className="llf-list">
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Tibialis anterior overload:</strong> aching or burning along the front of
                      the shin, especially with walking or downhill movement.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Outer lower leg strain:</strong> soreness along the fibularis/peroneal
                      muscles on the outside of the lower leg.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Early “shin splints” feelings:</strong> tightness or pulling that builds
                      with activity and eases with rest.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Fatigue with walking:</strong> feeling like the foot slaps down or the
                      muscles tire quickly on longer walks.
                    </span>
                  </li>
                </ul>

                <div className="llf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="llf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your lower leg symptoms fit →
                  </button>
                  <button
                    className="llf-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="llf-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/lower-leg-front/lower_leg_tibialis.png"
                  alt="Therapist treating shin and tibialis anterior"
                  className="llf-img"
                />
              </div>
            </div>

            <div className="llf-cardGrid">
              <div className="llf-card">
                <div className="llf-cardTitle">Tibialis Anterior (front shin)</div>
                <div className="llf-cardText">
                  Helps lift the foot so you don&apos;t trip on the ground and controls how your foot lands.
                </div>
              </div>
              <div className="llf-card">
                <div className="llf-cardTitle">Fibularis / Peroneals (outer lower leg)</div>
                <div className="llf-cardText">
                  Help prevent the ankle from rolling and assist with pushing the foot down and out.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="llf-stripe">
            <div className="llf-flexRow">
              <div className="llf-flexCol">
                <img
                  src="/content/lower-leg-front/lower_leg_peroneals.png"
                  alt="Manual therapy on outer lower leg muscles"
                  className="llf-img"
                />
              </div>

              <div className="llf-flexCol">
                <div className="llf-sectionTitle">How physical therapy supports the lower leg</div>
                <p className="llf-sectionSubtitle">
                  We check how your shin and outer leg are working together with your foot, ankle, and
                  hips, then build a plan that matches your activity level.
                </p>

                <ul className="llf-list">
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> targeted treatment to tibialis anterior,
                      peroneals, and surrounding muscles to reduce tension.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Range-of-motion & mobility:</strong> gentle motions for the ankle and
                      foot to improve how the lower leg can work.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Strength & endurance:</strong> specific exercises to help these muscles
                      handle walking, stairs, or running without over-fatiguing.
                    </span>
                  </li>
                  <li>
                    <span className="llf-bullet" />
                    <span>
                      <strong>Footwear & surface guidance:</strong> practical suggestions on shoes,
                      inserts, or training surfaces when appropriate.
                    </span>
                  </li>
                </ul>

                <div className="llf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="llf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one lower leg session →
                  </button>
                  <button
                    className="llf-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="llf-stripe">
            <div className="llf-sectionTitle">What a lower leg session may look like</div>

            <div className="llf-flexRow">
              <div className="llf-flexCol">
                <img
                  src="/content/lower-leg-front/lower_leg_exercises.png"
                  alt="Patient doing lower leg and ankle exercises"
                  className="llf-img"
                />
              </div>

              <div className="llf-flexCol">
                <div className="llf-timeline">
                  <div className="llf-step">
                    <div className="llf-stepLabel">1. Your story</div>
                    <div className="llf-stepText">
                      When does the lower leg bother you most—first steps, longer walks, hills, or after activity?
                    </div>
                  </div>
                  <div className="llf-step">
                    <div className="llf-stepLabel">2. Motion & strength check</div>
                    <div className="llf-stepText">
                      We look at ankle motion, foot strength, and how your shin and outer leg control each step.
                    </div>
                  </div>
                  <div className="llf-step">
                    <div className="llf-stepLabel">3. Hands-on care</div>
                    <div className="llf-stepText">
                      You try specific manual techniques and movements to see what reduces tightness or ache.
                    </div>
                  </div>
                  <div className="llf-step">
                    <div className="llf-stepLabel">4. Focused exercises</div>
                    <div className="llf-stepText">
                      You leave with a small set of shin and ankle exercises you can repeat without feeling overwhelmed.
                    </div>
                  </div>
                </div>

                <div className="llf-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="llf-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a lower leg evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="llf-stripe">
            <div className="llf-banner">
              <img
                src="/content/lower-leg-front/lower_leg_banner.png"
                alt="Bright physical therapy clinic for lower leg and ankle"
              />
              <div className="llf-bannerOverlay">
                <div className="llf-bannerText">
                  Lower leg sessions happen in a calm, one-on-one environment where we match your plan
                  to your walking, work, or sport goals.
                </div>
                <div className="llf-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a lower leg visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="llf-stripe">
            <div className="llf-bottomStrip">
              <div className="llf-bottomText">
                If you notice sudden severe lower leg pain, a feeling of tearing, major swelling, redness,
                warmth, or symptoms like chest pain or shortness of breath,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help support
                recovery once serious causes are ruled out.
              </div>
              <div className="llf-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule lower leg PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default LowerLegFrontPT;
